export const URL_STATIC = process.env.REACT_APP_URL_STATIC ?? ''
export const APIKEY_ADOLARES = process.env.REACT_APP_APIKEY_ADOLARES ?? ''
export const APIKEY_ASOLES = process.env.REACT_APP_APIKEY_ASOLES ?? ''